module.exports = __webpack_public_path__ + "static/img/tram.b4a523f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/melbourne/tram.jpg
// module id = 120
// module chunks = 1